import * as React from 'react';
import Notification from '../models/Notification';
import NotificationChannel from 'src/modules/organization/models/NotificationChannel';
import NotificationMgmtService from '../services/NotificationMgmtService';
import NotificationChannelMgmtService from 'src/modules/shared/services/NotificationChannelMgmtService';
import Loading from '../../shared/components/loading/Loading';
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  WithStyles,
  Paper,
  Button,
} from '@material-ui/core';
import { NotInterested } from '@material-ui/icons';
import { withStyles, StyleRules } from '@material-ui/core/styles';
import { withRouter, RouteComponentProps } from 'react-router';
import DateHelper from 'src/modules/shared/helpers/DateHelper';
import AddAlertIcon from '@material-ui/icons/AddAlert';

const styles: StyleRules = {
  table: {
    padding: 24,
    paddingTop: 0,
  },
  tableHead: {
    '& th': {
      width: '14.29%',
    },
  },
  tableRow: {
    height: 40,
  },
  link: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  icons: {
    fontSize: 20,
  },
};

interface IState {
  notifications: Notification[];
  notificationChannels: NotificationChannel[];
  isLoading: boolean;
}

interface IProps extends WithStyles<typeof styles>, RouteComponentProps<any> {}

class NotificationOverview extends React.Component<IProps> {
  public static SortNotifications = (
    notificationA: Notification,
    notificationB: Notification
  ) => {
    return (
      new Date(notificationB.updatedOn).getTime() -
      new Date(notificationA.updatedOn).getTime()
    );
  };

  public state: IState = {
    notifications: [],
    notificationChannels: [],
    isLoading: true,
  };

  public async componentDidMount() {
    const notificationDataPromises = [
      NotificationMgmtService.GetNotifications(this.props.match.params.assetId),
      NotificationChannelMgmtService.GetNotificationChannels(),
    ];
    const notificationData = await Promise.all(notificationDataPromises);

    this.setState({
      notifications: notificationData[0],
      notificationChannels: notificationData[1],
      isLoading: false,
    });
  }

  public getChannelForNotification = (notification: Notification) => {
    const { notificationChannels } = this.state;
    return notificationChannels.find(
      channel => channel.id === notification.channelId
    );
  };

  public renderNotification = (notification: Notification) => {
    const { classes, match, history } = this.props;
    const channel = this.getChannelForNotification(notification);

    return (
      <TableRow
        hover
        tabIndex={-1}
        key={notification.id}
        className={classes.tableRow}
      >
        <TableCell padding="none">{notification.name}</TableCell>
        <TableCell
          padding="none"
          onClick={
            channel &&
            (() => {
              history.push(
                `/organization/notificationchannels/${channel.channelTypeId.toLocaleLowerCase()}/${
                  channel.id
                }`
              );
            })
          }
          className={classes.link}
        >
          {channel && channel.name}
        </TableCell>
        <TableCell padding="none">{channel && channel.channelTypeId}</TableCell>
        <TableCell padding="none">
          {notification.type ? (
            notification.type.type
          ) : (
            <NotInterested className={classes.icons} />
          )}
        </TableCell>
        <TableCell padding="none">{notification.timesRan}</TableCell>
        <TableCell padding="none">
          {notification.lastRun
            ? DateHelper.GetDaysAgo(notification.lastRun)
            : 'Never'}
        </TableCell>
        <TableCell padding="none">
          {DateHelper.FormatDate(notification.updatedOn)}
        </TableCell>
        <TableCell
          padding="none"
          onClick={() => {
            history.push(
              `/subscriptions/${match.params.assetId}/${match.params.environment}/notifications/${notification.id}`
            );
          }}
          className={classes.link}
        >
          Edit
        </TableCell>
      </TableRow>
    );
  };

  public render() {
    const { notifications, isLoading } = this.state;
    const { classes, match, history } = this.props;

    return (
      <React.Fragment>
        <div className="padding-bottom-15">
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => {
              history.push(
                `/subscriptions/${match.params.assetId}/${match.params.environment}/notifications/add`
              );
            }}
          >
            <AddAlertIcon className="margin-right-8" /> Add Notification
          </Button>
        </div>
        {isLoading ? (
          <div>
            <Loading />
          </div>
        ) : (
          <Paper>
            <div className={classes.table}>
              <Table aria-labelledby="tableTitle">
                <TableHead className={classes.tableHead}>
                  <TableRow>
                    <TableCell padding="none">Name</TableCell>
                    <TableCell padding="none">Channel Name</TableCell>
                    <TableCell padding="none">Channel Type</TableCell>
                    <TableCell padding="none">Notification Type</TableCell>
                    <TableCell padding="none">Times Ran</TableCell>
                    <TableCell padding="none">Last Run</TableCell>
                    <TableCell padding="none">Last Update</TableCell>
                    <TableCell padding="none">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {notifications
                    .sort(NotificationOverview.SortNotifications)
                    .map(this.renderNotification)}
                </TableBody>
              </Table>
            </div>
          </Paper>
        )}
      </React.Fragment>
    );
  }
}

export default withRouter(withStyles(styles)(NotificationOverview));



// WEBPACK FOOTER //
// ./src/modules/consumer/components/NotificationOverview.tsx